import type { ComponentIssue, FeComponentDescriptor } from '../registry';
import { defaultExpectedLossConfig, expectedLossConfigSchema, parseConfig } from './config';
import { ExpectedLossEditorBody } from './EditorBody';
import { ExpectedLossSettingsForm } from './SettingsForm';

// First reusable component + the sizing demo (sizing UI lands in phase 2).
export const assessmentExpectedLossDescriptor: FeComponentDescriptor = {
  id: 'assessmentExpectedLoss',
  label: 'Assessment expected loss',
  version: 1,
  defaultConfig: { ...defaultExpectedLossConfig },
  configSchema: expectedLossConfigSchema,
  // The sizing demo: full → quarter presets + free edge-drag (min 20%).
  sizing: { presets: ['full', 'twoThirds', 'half', 'third', 'quarter'], minFraction: 0.2, resizable: true },
  SettingsForm: ExpectedLossSettingsForm,
  EditorBody: ExpectedLossEditorBody,
  validate: ({ sourceId, data, config }): ComponentIssue[] => {
    if (!sourceId) return [{ level: 'error', message: 'Pick an assessment to source the figure' }];
    if (!data) return [{ level: 'error', message: 'No data embedded — open settings and re-select the assessment' }];
    const which = parseConfig(config).which;
    if (typeof data[which] !== 'number') {
      return [{ level: 'warning', message: `${which} expected loss is unavailable for this assessment` }];
    }
    return [];
  },
};
